const mixinsObj = {
  filters: {
    formateRedGreen: function (v) {
      if (v == undefined || v == null) return;
      if (v > 0) return 'red';
      if (v < 0) return 'green';
    },
    gains: function (val, str) {
      if (val || val === 0) {
        let multiple = Math.pow(10, 2);
        return (Math.round(val * multiple) / multiple).toFixed(2) + str;
      } else {
        return '--';
      }
    }
  },
  methods: {
    /**
     *  是否是大智慧APP
     *
     */
    isDzhApp() {
      if (typeof DzhAppJs == 'undefined') {
        // 外部
        return false;
      } else {
        return true;
      }
    },

    /**
     *  获取字符长度，每个中文为2个字符
     *
     * @param {string} [value] 文本内容
     */
    getByteLen(val) {
      let len = 0;
      for (let i = 0; i < val.length; i++) {
        let length = val.charCodeAt(i);
        if (length >= 0 && length <= 128) {
          len += 1;
        } else {
          len += 2;
        }
      }
      return len;
    },

    /**
     * @description 获取url？后面的参数  paramName：要获取的参数名
     * @param paramName
     * @returns {paramName}
     */

    getUrlQuery(paramName) {
      let url = document.location.toString();
      let arrObj = url.split('?');
      if (arrObj.length > 1) {
        let arrPara = arrObj[1].split('&');
        let arr;
        for (let i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split('=');

          if (arr != null && arr[0] === paramName) {
            return arr[1];
          }
        }
        return '';
      } else {
        return '';
      }
    },

    // 处理数据
    toFixedNum(value, toFixed = 2, unit = '') {
      if (value && value !== '--') {
        return Number(value).toFixed(toFixed) + unit;
      } else if (value === 0) {
        return '0.00' + unit;
      } else {
        return '--';
      }
    },

    /**
     * 获取近一年的时间戳
     * @param {} yearNum
     * @returns
     */
    getLastYear(yearNum = 1) {
      var timestamp = new Date().getTime();
      timestamp = timestamp - 24 * 60 * 60 * 1000;
      let today = new Date(timestamp);
      // let today = new Date(); //当天
      today.setFullYear(today.getFullYear() - yearNum);
      return today;
    },

    /**
     * 获取昨天的时间戳
     * @returns
     */
    getLastDay() {
      var timestamp = new Date().getTime();
      timestamp = timestamp - 24 * 60 * 60 * 1000;
      let today = new Date(timestamp);
      return today;
    },
    /**
     * 获取数组中最大值
     *
     * @param {*} arr
     * @return {*}
     */
    getMax(arr) {
      arr = arr.filter(Boolean);
      if (!arr.length) return 0;
      let t = parseFloat(arr[0] || 0);
      for (let i = 0; i < arr.length; i++) {
        let e = parseFloat(arr[i] || 0);
        if (Object.is(e, NaN)) {
          continue;
        }
        if (e > t) {
          t = e;
        }
      }
      return t;
    },
    /**
     * 处理日期  20220202转 2022-02-02
     */
    convertTime: function (str) {
      if (str && str.length >= 8) {
        return str.substr(0, 4) + '.' + str.substr(4, 2) + '.' + str.substr(6, 2);
      } else {
        return str;
      }
    },
    /**
     * 处理日期  202202020923转 09-23
     */
    convertyr: function (str) {
      if (str && str.length >= 8) {
        return str.substr(8, 2) + ':' + str.substr(10, 2);
      } else {
        return str;
      }
    },
    // 处理金额
    process: function (value, fixed = 2, isZero, baseValue) {
      if (value) {
        if (!isNaN(value)) {
          value = Number(value);
          let len = parseInt(Math.abs(value), 10).toString().length;
          if (baseValue === '元' || baseValue === '') {
            value =
              (len > 12 && value / 1000000000000) ||
              (len > 8 && value / 100000000) ||
              (len > 4 && value / 10000) ||
              value;
          } else if (baseValue === '万') {
            value = (len > 8 && value / 100000000) || (len > 4 && value / 10000) || value;
          } else if (baseValue === '亿') {
            value = (len > 4 && value / 10000) || value;
          }
          if (
            !isZero ||
            (!/^[-+]?\d*$/.test(value.toString()) && value.toString().split('.')[1].length > fixed)
          ) {
            value = value.toFixed(fixed);
          }
          if (baseValue === '元' || baseValue === '') {
            value =
              (len > 12 && value + '万亿') ||
              (len > 8 && value + '亿') ||
              (len > 4 && value + '万') ||
              value + baseValue;
          } else if (baseValue === '万') {
            value = (len > 8 && value + '万亿') || (len > 4 && value + '亿') || value + '万';
          } else if (baseValue === '亿') {
            value = (len > 4 && value + '万亿') || value + '亿';
          }
        }
      } else if (value === 0) {
        value = '0.00';
      } else {
        value = '--';
      }
      return value;
    },
    /**
     * 替换 操作参考 (模拟交易 调仓用)
     *
     * @export
     * @param {*} str
     */
    strStyle(number) {
      switch (number) {
        case 1:
          return '信号调入';
          break;
        case 2:
          return '到期调出';
          break;
        case 3:
          return '策略止盈';
          break;
        case 4:
          return '策略止损';
          break;

        default:
          return '--';
          break;
      }
    },
    // 跳转分时
    gogufs: function (stockCode) {
      window.location.href = `dzh_browser_url&goto=0&type=2970&code=${stockCode}&kind=1`;
    },
    /**
     * 跳转分时BS点(新)
     * @param {*} stockCode 股票代码
     * @param {*} obj 传参对象 base64字符串
     * @param {*} num  num:1模拟交易 2量化回测
     */
    gotoNewsFenShi: function (stockCode, obj, num) {
      window.location.href = `dzh_browser_url&goto=0&type=2944&code=${stockCode}&kind=1&obj=${obj}&bsType=${num}`;
    },

    //获取当前的网址
    getBaseUrl: function () {
      // 在组件挂载后获取当前页面的网址
      const url = window.location.href;

      // 使用 URL 对象解析网址
      const parsedUrl = new URL(url);

      // 提取出网址的基础部分
      const baseUrl = `${parsedUrl.protocol}//${parsedUrl.host}`;

      return baseUrl;
    },

    /**
     *  获取 url 参数
     *
     * @param {string} [name] 参数名
     */
    getUrlKey: function (name) {
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [
            ,
            ''
          ])[1].replace(/\+/g, '%20')
        ) || null
      );
    },

    /**
     * APP内跳转url
     */
    gotoUrlInfo(url, name, obj) {
      if (this.isDzhApp()) {
        const query = {
          DZHSPECIAL: '264',
          token: this.getUrlKey('token', '')
        };
        Object.assign(query, obj);
        console.log('query', query);
        this.$router.push({ path: url, name: name, query: query });
      } else {
        const query = {
          DZHSPECIAL: '264',
          token: this.getUrlKey('token', '')
        };
        Object.assign(query, obj);
        console.log('query', query);
        this.$router.push({ path: url, name: name, query: query });
      }
    },

    //删除股票代码的前缀
    removePrefix(str) {
      if (typeof str !== 'string' || str.length < 2) {
        return str;
      }
      return str.substring(2);
    },

    scrollviewBounces(num) {
      if (this.isDzhApp()) {
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc('setAlwaysBounceVertical', num, '');
      }
    },

    /**
     * const myCookieValue = getCookie("myCookie");
     * console.log(myCookieValue);
     */

    // 获取特定Cookie的值
    getCookie(cookieName) {
      const cookiesString = document.cookie;
      const cookiesArray = cookiesString.split('; ');

      for (const cookie of cookiesArray) {
        const [name, value] = cookie.split('=');
        if (name === cookieName) {
          return decodeURIComponent(value);
        }
      }

      // 如果未找到匹配的Cookie，则返回null或可以根据需求选择适当的返回值
      return null;
    },
    // localStorage储存
    setLocalData: function (data) {
      if (data) {
        localStorage.setItem('cl', data.cl);
        localStorage.setItem('mn', data.mn);
        localStorage.setItem('hc', data.hc);
        localStorage.setItem('bccl', data.bccl);
        localStorage.setItem('openMn', data.openMn);
        localStorage.setItem('ccxy', data.ccxy);
      } else {
        localStorage.setItem('cl', false);
        localStorage.setItem('mn', false);
        localStorage.setItem('hc', false);
        localStorage.setItem('bccl', false);
        localStorage.setItem('openMn', false);
        localStorage.setItem('ccxy', false);
      }
    }
  }
};

export default mixinsObj;
